const HEX_NAME_MAP = {
  "#000000": "Black",
  "#ffffff": "White",
  "#d1d5db": "Light Grey",
  "#c8b68c": "Euro Oak",
};
const NAME_HEX_MAP = {
  black: "#000000",
  white: "#ffffff",
  "light grey": "#d1d5db",
  "euro oak": "#c8b68c",
};

export function normalizeColors(colors) {
  if (!Array.isArray(colors)) return [];
  return colors.map((c) => {
    if (typeof c === "string") {
      const lower = c.toLowerCase().trim();
      const hex = NAME_HEX_MAP[lower];
      return { name: c, hex: hex || (lower.startsWith("#") ? lower : undefined) };
    }
    return { name: c.name, hex: c.hex };
  });
}
